import axios from 'axios'
import {
  HttpResponse
} from 'aws-sdk'

var http = axios.create({
  baseURL: process.env.API_BASE_URL + '/sales',
  headers: {
    'Content-Type': 'application/json'
  }
})

http.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status !== 401) return Promise.reject(error)

  var refreshAndRetry = new Promise(function (resolve) {
    axios.post(process.env.API_BASE_URL + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', JSON.stringify({
        value: response.data.refresh_token,
        expire: null
      }))

      localStorage.setItem('token', JSON.stringify({
        value: response.data.token,
        expire: null
      }))

      return Promise.resolve(response)
    }).then(function (response) {
      var failedRequest = error.config
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      axios.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse)
      })
    })
  })

  return refreshAndRetry
})

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  }
}

function getPembayaranList(pagination, search, callback) {
  var config = getConfig()

  var url = '/transactions?'

  if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage
  if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  }
  if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by
  http.get(url, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getPembayaranDetail(id, callback) {
  var config = getConfig()

  http.get('/transaction/' + id, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function updatePembayaranStatus(id, status, callback) {
  var config = getConfig()
  var param = {
    status: status
  }

  http.put('/transaction/' + id, param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getProdukList(pagination, search, callback) {
  var config = getConfig()
  var url = '/products?'

  if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage
  if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  }
  if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getProdukDetail(id, callback) {
  var config = getConfig()

  http.get('/product/' + id, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function addProduk(data, callback) {
  var config = getConfig()
  var param = {
    type: data.type,
    title: data.title,
    value: data.value,
    bonus_value: data.bonus_value,
    description: data.description,
    currency: data.currency,
    price: data.price,
    net_price: data.net_price,
    status: data.status,
    platform: data.platform,
    grade: data.grade,
    features: data.features
  }

  http.post('/product', param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function updateProduk(id, data, callback) {
  var config = getConfig()
  var param = {
    type: data.type,
    title: data.title,
    picture: data.picture,
    value: data.value,
    bonus_value: data.bonus_value,
    description: data.description,
    currency: data.currency,
    price: data.price,
    net_price: data.net_price,
    status: data.status,
    platform: data.platform,
    grade: data.grade,
    features: data.features
  }

  http.put('/product/' + id, param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function uploadProdukPicture(id, formData, callback) {
  var config = getConfig()
  var param = formData
  config.headers['Content-Type'] = 'multipart/form-data'

  http.put('/product/' + id + '/upload_picture', param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function updateAllProdukStatus(status, callback) {
  var config = getConfig()
  var param = {
    'status': status
  }

  http.put('/product/all_products', param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function deleteProduk(id, callback) {
  var config = getConfig()

  http.delete('/product/' + id, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getMetodePembayaranList(pagination, search, callback) {
  var config = getConfig()

  var url = '/payment_methods?'

  if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage
  if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  }
  if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getMetodePembayaranDetail(id, callback) {
  var config = getConfig()

  http.get('/payment_method/' + id, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function addMetodePembayaran(data, callback) {
  var config = getConfig()
  var param = {
    bank_name: data.bank_name,
    bank_code: data.bank_code,
    description: data.description,
    account_number: data.account_number,
    account_name: data.account_name,
    status: data.status,
    type: data.type
  }

  http.post('/payment_method', param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function addMetodePembayaranV2(data, callback) {
  var config = getConfig()
  // var param = {
  //   bank_name: data.bank_name,
  //   bank_code: data.bank_code,
  //   description: data.description,
  //   account_number: data.account_number,
  //   account_name: data.account_name,
  //   status: data.status,
  //   type: data.type
  // }

  http.post('/payment_method', data, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function updateMetodePembayaranV2(id, data, callback) {
  var config = getConfig()
  // var param = {
  //   bank_name: data.bank_name,
  //   bank_logo: data.bank_logo,
  //   bank_code: data.bank_code,
  //   description: data.description,
  //   account_number: data.account_number,
  //   account_name: data.account_name,
  //   status: data.status,
  //   type: data.type
  // }

  http.put('/payment_method/' + id, data, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function updateMetodePembayaran(id, data, callback) {
  var config = getConfig()
  var param = {
    bank_name: data.bank_name,
    bank_logo: data.bank_logo,
    bank_code: data.bank_code,
    description: data.description,
    account_number: data.account_number,
    account_name: data.account_name,
    status: data.status,
    type: data.type
  }

  http.put('/payment_method/' + id, param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function uploadMetodePembayaranBankLogo(id, formData, callback) {
  var config = getConfig()
  var param = formData
  config.headers['Content-Type'] = 'multipart/form-data'

  http.put('/payment_method/' + id + '/upload_logo', param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function updateAllMetodePembayaranStatus(status, callback) {
  var config = getConfig()
  var param = {
    'status': status
  }

  http.put('/payment_method/all_methods', param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function deleteMetodePembayaran(id, callback) {
  var config = getConfig()

  http.delete('/payment_method/' + id, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getTicketUsageList(pagination, search, callback) {
  var config = getConfig()

  var url = '/tickets_usage?'

  if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage
  if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  }
  if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getTicketUsageDetail(id, callback) {
  var config = getConfig()

  http.get('/ticket_usage/' + id, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getKatalogTiketList(pagination, search, callback) {
  var config = getConfig()

  var url = '/features_activation?'

  if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage
  if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  }
  if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        data: error.response.data,
        message: error.message
      })
    })
}

function getKatalogTiketDetail(id, callback) {
  var config = getConfig()

  http.get('/feature_activation/' + id, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function addKatalogTiket(data, callback) {
  var config = getConfig()
  var param = {
    type: data.type,
    title: data.title,
    value: (data.type === 'DUEL') ? 1 : data.value,
    description: data.description,
    ticket: data.ticket,
    status: data.status,
    is_subscription: data.is_subscription
  }

  http.post('/feature_activation', param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function updateKatalogTiket(id, data, callback) {
  var config = getConfig()
  var param = {
    type: data.type,
    title: data.title,
    value: (data.type === 'DUEL') ? 1 : data.value,
    picture: data.picture,
    description: data.description,
    ticket: data.ticket,
    status: data.status,
    is_subscription: data.is_subscription
  }

  http.put('/feature_activation/' + id, param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function updateAllKatalogTiketStatus(status, callback) {
  var config = getConfig()
  var param = {
    'status': status
  }

  http.put('/feature_activation/all_features', param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function deleteKatalogTiket(id, callback) {
  var config = getConfig()

  http.delete('/feature_activation/' + id, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function uploadKatalogTiketPicture(id, formData, callback) {
  var config = getConfig()
  var param = formData
  config.headers['Content-Type'] = 'multipart/form-data'

  http.put('/feature_activation/' + id + '/upload_picture', param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function createManualTransaction(data, callback) {
  var config = getConfig()
  var url = '/transaction'

  http.post(url, data, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    }).catch(function(error) {
      callback({
        success: false,
        data: error.message
      })
    })
  })
}

function getChannelList(pagination, search, callback) {
  var config = getConfig()
  var url = '/channels?'

  if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage
  if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  }
  if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

export default {
  getPembayaranList,
  getPembayaranDetail,
  updatePembayaranStatus,
  getProdukList,
  getProdukDetail,
  addProduk,
  uploadProdukPicture,
  updateProduk,
  updateAllProdukStatus,
  deleteProduk,
  getMetodePembayaranList,
  getMetodePembayaranDetail,
  addMetodePembayaran,
  updateMetodePembayaranV2,
  addMetodePembayaranV2,
  updateMetodePembayaran,
  uploadMetodePembayaranBankLogo,
  updateAllMetodePembayaranStatus,
  deleteMetodePembayaran,
  getTicketUsageList,
  getTicketUsageDetail,
  getKatalogTiketList,
  getKatalogTiketDetail,
  addKatalogTiket,
  updateKatalogTiket,
  updateAllKatalogTiketStatus,
  uploadKatalogTiketPicture,
  deleteKatalogTiket,
  createManualTransaction,
  getChannelList
}



// WEBPACK FOOTER //
// ./src/services/sales.js